import _ from 'lodash';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PopoverService } from 'app/core/services/popover.service';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { Subject } from 'rxjs';

let id = 1;

@Component({
  selector: 'app-campaign-option-action-popover',
  templateUrl: './campaign-option-action-popover.component.html',
  styleUrl: './campaign-option-action-popover.component.scss'
})

export class CampaignOptionActionPopoverComponent {

  @Input() element = null;
  @Input() text: string = '';
  @Input() textClasses: string = '';

  @Output() popoverClicked = new EventEmitter<any>();

  @ViewChild('popover') popover: MdbPopoverDirective = null;
  
  public takeUntilSubject: Subject<any> = new Subject();

  private _id = id++;
  
  get id() {
    return `CampaignOptionActionPopoverEvent_${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
  ) { }

  onClick() {
    this.popoverClicked.emit(this.element.data);
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
